import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
// reference:  https://juristr.com/blog/2016/02/learning-ng2-creating-tab-component/
@Component({
    selector: 'app-tab',
    templateUrl: './tab.component.html'
})
export class TabComponent implements OnChanges {
    @Input('tabIcon') icon: string;
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() id = "";
    href = "javascript:void(0)";
    constructor() { }
    ngOnChanges(changes: SimpleChanges) {
        if ('id' in changes) {
            let id = changes['id'].currentValue;
            if (id) {
                this.href = '#' + id;
            }
        }
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/tabs/tab/tab.component.ts